import notify from 'bnc-notify'

export default notify({
    dappId: '93470207-965c-447c-b3c5-31851a1fb2e7',
    networkId: 1,
    darkMode: true,
    desktopPosition: 'topRight',
})
